<template>
    <div id="index">
        <el-container>
            <el-container>
                <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
                    <el-main class="index">
                        <el-breadcrumb
                                separator-class="el-icon-arrow-right"
                                class="mainBread"
                        >
                            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item>修改客户账号密码</el-breadcrumb-item>
                        </el-breadcrumb>
                        <el-form ref="ruleForm" class="ruleForm" :rules="rules" :model="ruleForm" label-width="200px">
                            <el-form-item :label="$t('title.tenantAccount')">
                                <el-input
                                        style="width: 300px"
                                        :value="ruleForm.userName"
                                        :disabled="true"
                                ></el-input>
                            </el-form-item>

                            <el-form-item :label="$t('tips.enterPwd')" prop="newPassword">
                                <el-input
                                        v-model="ruleForm.newPassword"
                                        type="password"
                                        style="width: 300px"

                                ></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('tips.enterAgain')" prop="pass2">
                                <el-input
                                        v-model="ruleForm.pass2"
                                        type="password"
                                        style="width: 300px"
                                ></el-input>
                            </el-form-item>
                            <!--                            <el-form-item :label="$t('desc.managerPwd')" prop="adminPassword">-->
                            <!--                                <el-input-->
                            <!--                                        v-model="ruleForm.adminPassword"-->
                            <!--                                        type="password"-->
                            <!--                                        style="width: 300px"-->
                            <!--                                ></el-input>-->
                            <!--                            </el-form-item>-->
                            <el-form-item>
                                <el-button type="primary" @click="resetPsw('ruleForm')">{{$t("button.confirm")}}
                                </el-button>
                                <el-button @click="back">{{$t("button.cancel")}}</el-button>
                            </el-form-item>
                        </el-form>
                    </el-main>
                </el-scrollbar>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {ResetCoustomerPassword} from '../../api/api'

    export default {
        name: "resetCustomerPwd",
        data() {
            var checkName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error(this.$t('tips.enterAgain')));
                } else if (value !== this.ruleForm.newPassword) {
                    callback(new Error(this.$t('tips.twoPawNotSanme')));
                } else {
                    callback();
                }
            }
            return {
                rules: {
                    newPassword: [{required: true, message: this.$t("tips.needed"), trigger: 'blur'}],
                    adminPassword: [{required: true, message: this.$t("tips.needed"), trigger: 'blur'}],
                    pass2: [
                        {required: true, message: this.$t("tips.needed"), trigger: 'blur'},
                        {validator: checkName, trigger: 'blur'}],
                },
                ruleForm: {
                    userId: "",
                    userName: "",
                    name: "",
                    newPassword: "",
                    pass2: "",
                    adminPassword: "",
                },
            }
        },
        computed: mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        mounted() {
            console.log(this.$route.params)
            this.ruleForm.adminPassword = this.$route.params.adminPassword
            this.ruleForm.userId = this.$route.params.userId
            this.ruleForm.name = this.$route.params.name
            this.ruleForm.userName = this.$route.params.userName
        },
        methods: {
            back() {
                this.$router.push("/customer/customerAccount")
            },
            resetPsw(ruleForm) {
                var that = this;
                // console.log(this.$refs['ruleForm'].validate)
                this.$refs[ruleForm].validate((valid) => {
                    if (valid) {
                        var data = this.ruleForm
                        ResetCoustomerPassword(data).then(res => {
                            if (res.success) {
                                this.$message.success(that.$t("tips.oprationSuccess"))
                                setTimeout(function () {
                                    that.$router.push("/customer/customerAccount")
                                }, 1000)
                            } else {
                                this.$message.error(res.error.message)
                            }
                        }).catch(err => {
                            this.$message.error(err.error.message)
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .index {
        position: relative !important;
        padding: 20px !important;
    }

    .ruleForm {
        background: #ffffff;
        padding: 10px 0;
    }
</style>
